export enum EnumApprovalStepStatus {
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  WAITING = "WAITING",
  REMOVED = "REMOVED",
}
